module.exports = __webpack_public_path__ + "static/media/A1en.bfd0f624.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A1en.png
// module id = 867
// module chunks = 0